import Popover, { PopoverProps } from "@/shared/data-display/popover";
import { twMerge } from "tailwind-merge";
import { AddButton, AddButtonProps } from "../add-button/add-button";

type AddButtonGroupProps = {
  buttonProps?: AddButtonProps;
  popoverProps?: PopoverProps;
};

export function AddButtonGroup({
  buttonProps,
  popoverProps,
}: AddButtonGroupProps) {
  return (
    <Popover
      trigger={"click"}
      classNames={{
        body: twMerge(
          "!p-1",
          "[&_button]:!w-full [&_button]:!text-left [&_button]:!justify-start",
        ),
      }}
      placement="bottomRight"
      {...popoverProps}
    >
      <AddButton {...buttonProps} />
    </Popover>
  );
}
